import {
  EMAIL_CONTENT_BLOCK_HORIZONTAL_PADDING,
  EMAIL_CONTENT_BLOCK_VERTICAL_PADDING,
  EMAIL_CONTENT_VERTICAL_SPACING,
} from 'common/builder/components/chart/FlowChart/components/Block/email/EmailContent/styleConstants'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const Wrapper: React.CSSProperties = {
  padding: `${toPx(EMAIL_CONTENT_BLOCK_VERTICAL_PADDING)} ${toPx(
    EMAIL_CONTENT_BLOCK_HORIZONTAL_PADDING,
  )}`,
  marginTop: toPx(EMAIL_CONTENT_VERTICAL_SPACING),
  background: sharedStyles.Colors.BLOCK_DEFAULT,
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
}
